
import User from "@/domain/model/user/User.js";
import RcDomainObject from "../../common/RcDomainObject.js";
import RegistrationMap from "./RegistrationMap.js";
import StringUtils from "@/utils/StringUtils.js";
import Company from "../company/Company.js";
import Employee from "../employee/Employee.js";
import Credentials from "../user/Credentials.js";

export default class Registration extends RcDomainObject {

  static MODEL_NAME = 'Registration';

  static Fields = {
    COMPANY_NAME: "companyName",
  }

  static Values = {
    States: {
    },
  }

  constructor(domain, data) {
    super(domain, data, Registration.MODEL_NAME);
  }

  fields() {
    return Registration.Fields;
  }

  find() {
    return this.domain.registrations().findById(this.id());
  }

  update() {
    var update = this.find();
    this.data = update.data;
    return this;
  }

  stats() {
    return this.domain.registrations().findStatsById(this.id());
  }

  withStateActive() {
    this.put(Registration.FIELDS.STATE, Registration.Values.States.ACTIVE);
    return this;
  }

  pointer() {
    var Registration = new Registration(this.domain);
    Registration.withId(this.id());
    return Registration;
  }

  map() {
    var map = new RegistrationMap(this.domain);
    map.add(this);
    return map;
  }

  modifiedBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.MODIFIED_BY));
  }

  createdBy() {
    return new User(this.domain, this.get(RcDomainObject.DefaultFields.CREATED_BY));
  }

  stateDisplay() {
    let state = this.state();
    if (StringUtils.startsWith(state, "active")) {
      return "Active"
    }
    if (StringUtils.startsWith(state, "inactive")) {
      return "Inactive"
    }
    if (StringUtils.startsWith(state, "deleted")) {
      return "Deleted"
    }
    return null;
  }

  company() {
    return new Company(this.domain, this.get(Company.MODEL_NAME));
  }

  user() {
    return new User(this.domain, this.get(User.MODEL_NAME));
  }
  employee() {
    return new Employee(this.domain, this.get(Employee.MODEL_NAME));
  }
  credentials() {
    return new Credentials(this.domain, this.get(Credentials.MODEL_NAME));
  }
}